import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MachineSalesDataSource, SalesHttpService } from '../../../../../app/core/sales';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatPaginator, MatDialogConfig, MatDialog, MatSort } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MachineRouteService } from '../machine-route.service';
import { tap } from 'rxjs/operators';
import { merge } from 'rxjs';
import * as XLSX from 'xlsx';
import { MixpanelService } from '../../../../services/mixpanel.service';
import { formatFreeVendProgress, parseDrinkSaleLabel, parsePayTypeLabel } from '../../../../../app/core/settings/_services/free-vend.util';
import { FeatureFlagService } from '../../../../../app/core/_services/feature-flag.service';

@Component({
  selector: 'kt-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.css']
})
export class SalesComponent implements OnInit , AfterViewInit {

	displayedColumns = ['drink', 'vendStatus', 'saleType', 'payType', 'utc_time_stamp'];
	canAccessFreeMode = false;

	dataSource: MachineSalesDataSource;

	searchBtnClicked = false;

	qParams = {};

	fileName = "Sales Report";

	private dialogConfig = new MatDialogConfig();

	vend_codes;

	ua_codes;

	selectedMachine: any;

	searchForm: FormGroup;

	lastEvalKey = [];

	tranType = 'all';

	@ViewChild(MatSort, {static: false}) sort: MatSort;

	lastPageIndex = -2;
	currentPageIndex = -1;

	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	@ViewChild('memberInput', {static: false}) input: ElementRef;

	constructor(private http: SalesHttpService, public dialog: MatDialog, private mixpanelService: MixpanelService, private route: ActivatedRoute, private machineRouteService: MachineRouteService, private featureFlagService: FeatureFlagService) { }

	// "@angular/material": "^8.2.3",
    // "@angular/material-moment-adapter": "^8.2.3",

	ngOnInit() {
		this.selectedMachine = this.machineRouteService.getMachine(this.route);
		if (!this.selectedMachine) return;
		this.canAccessFreeMode = this.featureFlagService.canAccessFreeMode();
		if (this.canAccessFreeMode) {
			this.displayedColumns = ['drink', 'vendStatus', 'saleType', 'payType', 'freeVend', 'utc_time_stamp'];
		}
		this.dataSource = new MachineSalesDataSource(this.http);
		this.searchForm = new FormGroup({
			tranType: new FormControl('all', [Validators.required]),
			startDate: new FormControl(new Date(), [Validators.required]),
			endDate: new FormControl(new Date(), [Validators.required])
		});
		this.qParams = {
			noPerPg: this.paginator.pageSize || 10,
			pgNo: this.paginator.pageIndex || 0,
			machine_id: this.selectedMachine.machine_id,
			sortKey: 'utc_time_stamp',
			sortVal: 'desc',
			// optFilterKey: 'log_type',
			// optFilterVal: this.logType || `'err','wrn'`,
			txtFilterKey: '',
			txtFilterVal: null,
			startDate: this.dateFormatUTC(this.searchForm.get('startDate').value, 'start'),
			endDate: null
		};
		this.dataSource.loadMacSalesList(this.qParams);

		this.mixpanelService.track(this.mixpanelService.PAGE_VIEW, {
			'Machine ID': this.selectedMachine.machine_id,
			'Machine Name': this.selectedMachine.machine_name,
			'Machine Serial No': this.selectedMachine.serial_no
		}
	)}

	ngAfterViewInit() {
		this.searchBtnClicked = false;
		this.dataSource.counter$
		.pipe(
			tap((count) => {
				this.paginator.length = count;
			})
		)
		.subscribe();
		this.paginator.showFirstLastButtons = false;

		this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

		merge(this.paginator.page, this.sort.sortChange).pipe(
			tap(() => {
				this.lastPageIndex = this.currentPageIndex;
				this.currentPageIndex = this.paginator.pageIndex;
				this.loadSalesList();
				// alert( this.paginator.pageSize + '|' + this.paginator.pageIndex + ' | ' + this.paginator.hasNextPage());
			})
		)
		.subscribe();
	}

	onSubmited() {
		this.paginator.pageIndex = 0;
		this.searchBtnClicked = true;
		// console.log( '\'' + (this.searchForm.get('logDesc').value).join('\',\'') + '\'');
		this.qParams = {
			noPerPg: this.paginator.pageSize || 10,
			pgNo: this.paginator.pageIndex || 0,
			machine_id: this.selectedMachine.machine_id,
			sortKey: this.sort.active,
			sortVal: this.sort.direction,
			// optFilterKey: 'log_type',
			// optFilterVal: this.searchForm.get('logType').value,
			// txtFilterKey: 'log_desc',
			// txtFilterVal: this.searchForm.get('logDesc').value,
			startDate: this.dateFormatUTC(this.searchForm.get('startDate').value, 'start'),
			endDate: this.dateFormatUTC(this.searchForm.get('endDate').value, 'end')
		};
		this.dataSource.loadMacSalesList(this.qParams);
	}

	getReportData(): Promise<any[]> {
		const saleData = [];

		return new Promise((resolve, reject) => {
			this.qParams = {
				noPerPg: this.paginator.length,
				pgNo: this.paginator.pageIndex || 0,
				machine_id: this.selectedMachine.machine_id,
				sortKey: this.sort.active,
				sortVal: this.sort.direction,
				startDate: this.dateFormatUTC(this.searchForm.get('startDate').value, 'start'),
				endDate: this.dateFormatUTC(this.searchForm.get('endDate').value, 'end')
			};

			this.http.getMachineSales(this.qParams).subscribe(
				data => {
					saleData.push.apply(saleData, data.payload);
						resolve(saleData);
						console.log("Sale Data: ", saleData);
				},
				error => {
					reject(error);
				}
			);
		});

	}


	dateFormatUTC(date: Date, period: string) {
		let dateStr =
		`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${(date.getDate()).toString().padStart(2, '0')} `;
		if (period === 'start') {
			dateStr += '00:00:00';
		} else {
			dateStr += '23:59:59';
		}
		return new Date(dateStr.replace(/-/g, '/')).toISOString();
	}

	parseVendStatusCodes(code) {
		if (code == 1) {
			return "Success";
		} else {
			return "Failed";
		}
	}

	parseSaleType(code, payType) {
		return parseDrinkSaleLabel(code, payType, this.canAccessFreeMode);
	}

	parsePayType(payType) {
		return parsePayTypeLabel(payType);
	}

	parseFreeVendProgress(sale) {
		return formatFreeVendProgress(sale && sale.freeVendDrinkNumber, sale && sale.freeVendQuota);
	}

	parseDrinkSize(code){
		if(code == 'M'){
			return 'Medium';
		} else {
			return 'NA';
		}
	}

	offlineSale(code){
		if (code == 0) {
			return "Online";
		} else {
			return "Offline";
		}
	}

	loadSalesList() {
		const sdate = this.dateFormatUTC(this.searchForm.get('startDate').value, 'start');
		const edate = this.dateFormatUTC(this.searchForm.get('endDate').value, 'end');
		this.qParams = {
			noPerPg: this.paginator.pageSize || 10,
			pgNo: this.paginator.pageIndex || 0,
			machine_id: this.selectedMachine.machine_id,
			sortKey: this.sort.active,
			sortVal: this.sort.direction,
			// optFilterKey: 'log_type',
			// optFilterVal: this.searchForm.get('logType').value,
			// txtFilterKey: 'log_code',
			// txtFilterVal: this.searchForm.get('logDesc').value,
			startDate: this.dateFormatUTC(this.searchForm.get('startDate').value, 'start'),
			endDate: this.dateFormatUTC(this.searchForm.get('endDate').value, 'end')
		};
		this.dataSource.loadMacSalesList(this.qParams);
	}

	getUACodes() {
		this.http.getActivityCodes()
		.subscribe(ua_codes => {
			this.ua_codes = ua_codes;
			this.onSubmited();
		});
	}

	exportExcel(){
		console.log("Export Excel Clicked");
		console.log("LENGTH:", this.paginator.length);

		this.getReportData().then(data => {
			const formattedData = data.map(item => {
				const row: {[key: string]: string} = {
					Drink: item.drink,
					Size: this.parseDrinkSize(item.drinkSize),
					Status: this.parseVendStatusCodes(item.vendStatus),
					'Sale Type': this.parseSaleType(item.saleType, item.payType),
					'Pay Type': this.parsePayType(item.payType),
					Date: new Date(item.utc_time_stamp).toLocaleString()
				};
				if (this.canAccessFreeMode) {
					row['Free Vend'] = this.parseFreeVendProgress(item);
				}
				return row;
			});

		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);

		// Generate workbook and add the worksheet
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sales Report');

		// Save to file
		XLSX.writeFile(wb, this.selectedMachine.machine_id + " " + this.fileName + '.xlsx');

		}).catch(error => {
			console.error('Error fetching report data:', error);
		});

	}

}
